// extracted by mini-css-extract-plugin
export default {"attention":"attention-icon_attention__fCLcb","attention-admin":"attention-icon_attention-admin__Tcmat","attention-author":"attention-icon_attention-author__UB6Z0"};